// extracted by mini-css-extract-plugin
module.exports = {"root":"Ripple_root__FI8op","dark":"Ripple_dark__nrylw","ripple":"Ripple_ripple__YTqMP","pressed":"Ripple_pressed__Axou4","released":"Ripple_released__BGniJ"};